// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.student-block-container {
  border-radius: 10px;
  background-color: white;
  border: 1px solid #A7A9AC;
  display: flex;
  color: #333;
  margin: 20px 8px;
  min-height: 160px;
  padding: 5px;
  min-width: 400px;
  width: 48%;
}
.student-block-container .photo-container {
  border-radius: 10px;
  height: 170px;
  margin-left: -5px;
  margin-top: 6px;
}
.student-block-container .photo-container .student-image {
  width: 100%;
  height: 100%;
}
.student-block-container .photo-container img {
  border: 1px solid #333333;
}
.student-block-container .student-info-container {
  font-weight: 550;
}
.student-block-container .student-info-container .student-name {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 14px;
}
.student-block-container .student-info-container p {
  margin: -10px 0;
  font-size: 0.9rem;
}
.student-block-container .student-info-container p span {
  margin-left: 10px;
  font-weight: 400;
}
.student-block-container .student-info-container table {
  margin: -10px 0 -10px 0;
}
.student-block-container .student-info-container table > tbody > tr {
  border-bottom: 1px solid #D1D3D4;
}
.student-block-container .student-info-container table > tbody > tr.no-border {
  border: none;
}
.student-block-container .student-info-container table > tbody > tr > td {
  height: 5px;
  padding: -10;
  font-size: 0.9rem;
}
.student-block-container .student-info-container table > tbody > tr > td > i {
  font-size: 0.9rem;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/StudentInfoBlock.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;ECAI,mBDCsB;EACtB,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;AAUJ;AARI;ECZA,mBDa0B;EACtB,aAAA;EACA,iBAAA;EACA,eAAA;AAUR;AATQ;EACI,WAAA;EACA,YAAA;AAWZ;AATQ;EACI,yBAAA;AAWZ;AARI;EACI,gBAAA;AAUR;AATQ;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;AAWZ;AATQ;EACI,eAAA;EACA,iBAAA;AAWZ;AAVY;EACI,iBAAA;EACA,gBAAA;AAYhB;AATQ;EACI,uBAAA;AAWZ;AATQ;EACI,gCAAA;AAWZ;AATQ;EACI,YAAA;AAWZ;AATQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAWZ;AATQ;EACI,iBAAA;EACA,gBAAA;AAWZ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.student-block-container {\n    @include borderRadius(10px);\n    background-color: white;\n    border: 1px solid $grey2;\n    display: flex;\n    color: #333;\n    margin: 20px 8px;\n    min-height: 160px;\n    padding: 5px;\n    min-width: 400px;\n    width: 48%;\n\n    .photo-container {\n        @include borderRadius(10px);\n        height: 170px;\n        margin-left: -5px;\n        margin-top: 6px;\n        .student-image {\n            width: 100%;\n            height: 100%;\n        }\n        img {\n            border: 1px solid #333333;\n        }\n    }\n    .student-info-container {\n        font-weight: 550;\n        .student-name {\n            font-size: 1.25rem;\n            font-weight: 700;;\n            margin-bottom: 14px;\n        }\n        p {\n            margin: -10px 0;\n            font-size: 0.9rem;\n            span {\n                margin-left: 10px;\n                font-weight: 400;\n            }\n        }\n        table {\n            margin: -10px 0 -10px 0;\n        }\n        table>tbody>tr {\n            border-bottom: 1px solid $grey1;\n        }\n        table>tbody>tr.no-border {\n            border: none;\n        }\n        table>tbody>tr>td {\n            height: 5px;\n            padding: -10;\n            font-size: 0.9rem;\n        }\n        table>tbody>tr>td>i {\n            font-size: 0.9rem;\n            font-weight: 400;\n        }\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
